// Internal
import normalize from '~APP_UTIL/normalize';

// constants
const { createActionTypes } = normalize;

// Base
const BASENAME = 'GAMEDAY/ADMIN/';

// Types List
const types = ['GET_USERS', 'FETCH_ADMIN_USERS'];

export default createActionTypes(types, BASENAME);
